import Vue from 'vue'
import Vuex from 'vuex'
import qs from 'qs'

Vue.use(Vuex)

// Factory to create a fresh default state (so we can fully reset later)
const getDefaultState = () => ({
  review: {},
  caseInformation: {},
  reviews: [],
  formOptions: [],
  reviewerComment: {
    comment: '',
    reviewer: '',
    review: {}
  },
  reviewerComments: []
})

export default ({
  namespaced: true,

  // Use a fresh instance so RESET_STATE can restore this shape
  state: getDefaultState(),

  actions: {
    loadReview (context, reviewID) {
      Vue.axios.get('/api/case/load', { params: { id: reviewID } })
        .then((res) => {
          context.commit('LOAD_REVIEW', JSON.parse(res.data))
        })
    },

    loadFormOptions (context) {
      Vue.axios.get('/api/review/formOptions').then((res) => {
        context.commit('FORM_OPTIONS', res.data)
      })
    },

    saveReview (context) {
      const formData = new FormData()
      Object.keys(context.state.review).forEach((k) => {
        formData.append(k, context.state.review[k])
      })
      Vue.axios.post('/api/review/save', formData)
    },

    loadCaseInformation (context, caseID) {
      Vue.axios.get('/api/review/information', { params: { id: caseID } })
        .then((res) => {
          context.commit('CASE_INFORMATION', res.data)
        })
    },

    // Back-compat: previously cleared only parts; now fully resets via RESET_STATE
    resetReviewState (context) {
      context.commit('RESET_STATE')
    },

    // New, concise action for route-leave cleanup
    clear (context) {
      context.commit('RESET_STATE')
    },

    loadReviewerComments (context) {
      return Vue.axios.get('/api/reviewerComments/list', {
        params: { caseId: context.state.review.id }
      }).then((res) => {
        context.commit('REVIEWER_COMMENTS', JSON.parse(res.data))
      })
    },

    saveReviewerComment (context, reviewerComment) {
      context.commit('REVIEWER_COMMENT', reviewerComment)
      reviewerComment = qs.stringify(reviewerComment)
      return Vue.axios.post('/api/reviewerComments/save', reviewerComment).then((res) => res.data)
    },

    deleteReviewerComment (context, reviewerComment) {
      return Vue.axios.post('/api/reviewerComments/delete', qs.stringify(reviewerComment)).then((res) => res.data)
    },

    setReviewerComment (context, reviewerComment) {
      return context.commit('REVIEWER_COMMENT', reviewerComment)
    },

    clearReviewerComment (context) {
      return context.commit('REVIEWER_COMMENT', {
        comment: '',
        reviewer: '',
        review: {}
      })
    }
  },

  getters: {
    getReview (state) {
      return state.review
    },
    getFormOptions (state) {
      return state.formOptions
    },
    getCaseInformation (state) {
      return state.caseInformation
    },
    getReviewerComment (state) {
      return state.reviewerComment
    },
    getReviewerComments (state) {
      return state.reviewerComments
    }
  },

  mutations: {
    LOAD_REVIEW (state, review) {
      state.review = review
    },
    FORM_OPTIONS (state, formOptions) {
      state.formOptions = formOptions
    },
    CASE_INFORMATION (state, caseInformation) {
      state.caseInformation = caseInformation
    },
    REVIEWER_COMMENTS (state, reviewerComments) {
      state.reviewerComments = reviewerComments
    },
    REVIEWER_COMMENT (state, reviewerComment) {
      state.reviewerComment = reviewerComment
    },

    // 🚀 Full reset to initial state (fixes retained references/memory)
    RESET_STATE (state) {
      Object.assign(state, getDefaultState())
    }
  }
})
